import React, { FC } from 'react'
import { IonContent, IonHeader, IonModal } from '@ionic/react'
import { format } from '@dt/fe-utils'
import './index.scss'

interface IProps {
  resolve?: any;
  reject?: any;
  datas: {
    id: string | number;
    name: string;
    price: string | number;
    tips: string;
  }[];
  title: string;
}

const CommonDetailModal: FC<IProps> = ({ reject, title, datas }) => {
  return (
    <IonModal
      isOpen
      backdropDismiss
      cssClass='common-detail-modal'
    >
      <IonHeader>
        <div className='charge-top'>
          <span>{title}</span>
          <i className='iconfont icon-close' data-cypid='commonDetailModalClose' onClick={reject} />
        </div>
      </IonHeader>
      <IonContent>
        <div className='detail-list'>
          {
            datas.map(data => {
              return (
                <div className='item' key={data.id}>
                  <div>
                    <span className='name'>{data.name}</span>
                    <span className='dotted'></span>
                    <span className='price'>{format.toPrice(data.price)}</span>
                  </div>
                  <p>{data.tips}</p>
                </div>
              )
            })
          }
        </div>
      </IonContent>
    </IonModal>
  )
}

export default CommonDetailModal
